import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

// ========================================
// HELPER: MAP PRODUCT TYPES TO EMOJIS & TITLES
// ========================================
const getProductTypeConfig = (productType) => {
    const configs = {
        'Mugs': { emoji: '☕', title: 'This Week\'s Pick', subtitle: 'Mugs & Drinkware Collection' },
        'T-Shirts': { emoji: '👕', title: 'Weekly Favourite', subtitle: 'Retro Apparel Selection' },
        'Lighting': { emoji: '💡', title: 'Light Up Your Life', subtitle: 'Retro Lighting Collection' },
        'Poster': { emoji: '🎬', title: 'Frame This Week', subtitle: 'Wall Art & Posters' },
        'Collectibles': { emoji: '🎮', title: 'Collector\'s Choice', subtitle: 'Retro Collectibles' },
        'Hats': { emoji: '🧢', title: 'Top Pick', subtitle: 'Headwear Collection' },
        'Teddys': { emoji: '🧸', title: 'Cuddle Time', subtitle: 'Plush & Collectibles' },
    };

    return configs[productType] || {
        emoji: '⭐',
        title: 'Featured This Week',
        subtitle: 'Handpicked Selection'
    };
};

const SpotlightProduct = ({
                              product,
                              spotlightNumber,
                              title,
                              subtitle,
                              badgeText,
                              reverseLayout = false,
                              hideHeader = false,
                              truncateDescription
                          }) => {
    const navigate = useNavigate();

    if (!product) return null;

    // Get dynamic config based on product type (if not provided)
    const config = getProductTypeConfig(product.productType);
    const displayTitle = title || config.title;
    const displaySubtitle = subtitle || config.subtitle;
    const displayBadgeText = badgeText || `${config.emoji} ${product.productType} ${spotlightNumber === 1 ? 'Featured' : spotlightNumber === 2 ? 'of the Week' : spotlightNumber === 3 ? 'Pick' : 'Highlight'}`;

    return (
        <section className="product-spotlight">
            <Container>
                {!hideHeader && (
                    <div className="spotlight-section-header">
                        <div>
                            <h2 className="spotlight-section-title">{displayTitle}</h2>
                            <p className="spotlight-section-subtitle">{displaySubtitle}</p>
                        </div>
                    </div>
                )}
                <Row className="align-items-center">
                    <Col lg={6} className={`spotlight-image-col ${reverseLayout ? 'order-lg-2' : ''}`}>
                        <div
                            className="spotlight-image-wrapper"
                            onClick={() => navigate(`/product/${product.slug || product._id}`)}
                            style={{ cursor: 'pointer' }}
                        >
                            <div
                                className="spotlight-badge"
                                style={{
                                    backgroundColor: 'rgba(253, 112, 20, 0.5)!important',
                                    color: '#FFFFFF'
                                }}
                            >
                                {displayBadgeText}
                            </div>
                            <img
                                src={product.image}
                                alt={product.name}
                                className="spotlight-image"
                            />
                        </div>
                    </Col>

                    <Col lg={6} className={`spotlight-content-col ${reverseLayout ? 'order-lg-1' : ''}`}>
                        <div className="spotlight-content">
                            <h2 className="spotlight-title">{product.name}</h2>

                            <div className="spotlight-description">
                                <p>{truncateDescription(product?.description, 200)}</p>

                                <div className="spotlight-rating">
                                    <span className="spotlight-stars">
                                        {'★'.repeat(Math.floor(product.rating || 0))}
                                        {'☆'.repeat(5 - Math.floor(product.rating || 0))}
                                    </span>
                                    <span className="spotlight-review-count">
                                        ({product.numReviews || 0} review{product.numReviews === 1 ? '' : 's'})
                                    </span>
                                </div>
                            </div>

                            <div className="spotlight-price-section">
                                <span className="spotlight-price">£{product.price}</span>
                            </div>

                            <div className="spotlight-buttons">
                                <Button
                                    className="spotlight-btn-primary"
                                    onClick={() => navigate(`/product/${product.slug || product._id}`)}
                                    style={{
                                        backgroundColor: '#FD7014',
                                        borderColor: '#FD7014',
                                        color: '#FFFFFF'
                                    }}
                                >
                                    View Product Details
                                </Button>
                                <Button
                                    className="spotlight-btn-secondary"
                                    onClick={() => navigate(`/search/${product.productType}`)}
                                >
                                    Browse More
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default SpotlightProduct;